/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { VerificationRequestSource } from './';
import {
    VerificationRequestSourceFromJSON,
    VerificationRequestSourceFromJSONTyped,
    VerificationRequestSourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface VerificationRequestCreationResource
 */
export interface VerificationRequestCreationResource {
    /**
     * 
     * @type {VerificationRequestSource}
     * @memberof VerificationRequestCreationResource
     */
    requestSource: VerificationRequestSource;
}

/**
 * Check if a given object implements the VerificationRequestCreationResource interface.
 */
export function instanceOfVerificationRequestCreationResource(value: object): value is VerificationRequestCreationResource {
    if (!('requestSource' in value) || value['requestSource'] === undefined) return false;
    return true;
}

export function VerificationRequestCreationResourceFromJSON(json: any): VerificationRequestCreationResource {
    return VerificationRequestCreationResourceFromJSONTyped(json, false);
}

export function VerificationRequestCreationResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): VerificationRequestCreationResource {
    if (json == null) {
        return json;
    }
    return {
        
        'requestSource': VerificationRequestSourceFromJSON(json['requestSource']),
    };
}

export function VerificationRequestCreationResourceToJSON(value?: VerificationRequestCreationResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'requestSource': VerificationRequestSourceToJSON(value['requestSource']),
    };
}

